import {useWorkflowIds} from "../../common/OrganizationConfig/useWorkflowIds";
import {
  CommodityTypesGetApiArg,
  useGetCommodityTypesQuery,
} from "./commodityTypes-api";

export type GetCommodityTypesQueryValues = {
  search?: string;
};

export const useGetCommodityTypes = ({
  search = "",
}: GetCommodityTypesQueryValues) => {
  const {getCommodityTypesWorkflowId} = useWorkflowIds();

  const args: CommodityTypesGetApiArg = {
    workflowId: getCommodityTypesWorkflowId,
    values: {
      variables: {
        search: search,
      },
    },
  };

  const {data, isLoading, isSuccess, isError, error} =
    useGetCommodityTypesQuery(args);

  return {
    data: data?.outputs,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
